import _ from 'lodash';
import dotenv from 'dotenv';
import moment from 'moment';
import numeral from 'numeral';

// Initialize configuration with .env file.
dotenv.config();

// Set default moment format.
moment.locale('es');
moment.defaultFormat = 'YYYY-MM-DD HH:mm:ss';

// Set default numeral formats.
require('numeral/locales/es');
numeral.locale('es');
numeral.defaultIntegerFormat = '0,0';
numeral.defaultDecimalFormat = '0,0.00';
numeral.defaultBalanceFormat = '$ 0,0.00';

// Set default lodash truncate options.
_.defaultTruncateOptions = {
    length: 24,
    separator: ' '
};
